import { LinearProgress, LinearProgressProps } from '@mui/material';

export default function Loading(progressProps: LinearProgressProps) {
  return <LinearProgress {...progressProps} />;
}
